import CavesServices from "./CavesServices.js";

export default {
  getWeatherInfo(cityName) {
    return CavesServices.getEndpointForWeatherInfo(cityName);
  }
};
